import { render, staticRenderFns } from "./DashboardFloor.vue?vue&type=template&id=ce36b418"
import script from "./DashboardFloor.vue?vue&type=script&lang=js"
export * from "./DashboardFloor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports